import { useState, useEffect, useMemo } from 'react';
import { checkIfLookFeaturesReceived } from "../../../api/look-api";
import { getCurrentLayout } from "../../appLayout";
import {
  isDevMode,
  SQFT_FEATURES
} from "../constants";
import {hardCodeIsHomeDepot, hardCodeIsRenuit} from "../../../misc/fabricatorHardcode";
import {matchesAllowedCombo} from "../helpers/sqft3dArHelper";

const useFetchFeatures = (partIds,
                          searchText = "",
                          shouldGetModelsOnlyWithThirdPartyAR3DUrls = false,
                          selectedFilters
) => {
  const [featuresData, setFeaturesData] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  const layout = useMemo(() => getCurrentLayout(), []);

  useEffect(() => {
    let isMounted = true;
    const fetchAllRows = async () => {
      setIsLoading(true);
      const newFeaturesData = {};

      for (const partId of partIds) {
        const featureGroup = layout.getFeatureGroupByPartId(partId);
        let navItems = [];

        if (featureGroup) {
          // If features are not received and no request is in progress, wait for the promise
          if (!featureGroup.allFeaturesReceived && !featureGroup.requestInProgress) {
            await checkIfLookFeaturesReceived(featureGroup);
          }

          navItems = layout.designNavigationItems(
            { part: featureGroup },
            selectedFilters,
            searchText,
            null,
            "all",
            [],
            { firstFeature: null, firstConditions: null },
          )

          if (shouldGetModelsOnlyWithThirdPartyAR3DUrls) {
            navItems = navItems.filter(feature => {
              return feature.part
                && feature.part.dbFeature
                && Array.isArray(feature.part.dbFeature.thirdPartyAR3DUrls)
                && feature.part.dbFeature.thirdPartyAR3DUrls.length > 0
            })
          }

          if ([SQFT_FEATURES.top_cabinet, SQFT_FEATURES.bottom_cabinet, SQFT_FEATURES.tall_cabinet].includes(partId)) {
            if (!isDevMode() && (hardCodeIsHomeDepot() || hardCodeIsRenuit())) {
              navItems = navItems.filter(feature => {
                const featureName = feature.part.getFeatureName?.() ?? "";
                const sharedFeatureName = feature.part.getLowerCasedSharedFeatureName?.() ?? "";
                return matchesAllowedCombo(featureName, sharedFeatureName);
              });
            }
          }
        }

        newFeaturesData[partId] = {
          rows: navItems,
          featureGroup: featureGroup,
        };
      }

      if (isMounted) {
        setFeaturesData(newFeaturesData);
        setIsLoading(false);
      }
    };

    fetchAllRows();

    return () => {
      isMounted = false;
    };
  }, [partIds, searchText, layout, shouldGetModelsOnlyWithThirdPartyAR3DUrls, selectedFilters]);

  return { featuresData, isLoading };
};

export default useFetchFeatures;
